import React  from "react";
import { isValid } from "../../utils/utilities";


export const BalanceAmount = () => {

    if(isValid(global.travelsAppConfig['SHOW_BALANCE_IN_SEARCH_PAGE']) && global.travelsAppConfig['SHOW_BALANCE_IN_SEARCH_PAGE']){
        if(isValid(global.agentType)&&global.agentType == "Prepaid"){
            return (
                <div className="balance-top-block">
                    <span className="search-page-balance-amount">
                        Wallet Balance : {global.amountLimit}
                    </span>
                </div>
            )
        }else if(isValid(global.agentType)&&global.agentType == "Postpaid"){
            return (
                <div className="balance-top-block">
                    <span className="search-page-balance-amount">
                        Balance Due : {global.amountDue}
                    </span>
                </div>
            )
        }else{
            return null;
        }
    }else{
        return null;
    }
}
